import type { SelectionChangedEvent } from 'ag-grid-community';
import { useCallback } from 'react';

export function useOnSelectionChangedHandler<Item>(onSelectedItemsChanged?: (selectedItems: Item[]) => void) {
  return useCallback(
    (event: SelectionChangedEvent<Item>) => {
      const selectedRows: Item[] = event.api.getSelectedRows();
      onSelectedItemsChanged?.(selectedRows);
    },
    [onSelectedItemsChanged],
  );
}
